import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PlenaLogo } from "../components/PlenaLogo";

export default function MfaSetup() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  if (user && user.role !== "admin") return <Navigate to="/workspace" replace />;
  if (user?.mfa_enabled) return <Navigate to="/admin" replace />;

  const begin = async () => {
    setError("");
    try { setSetup((await api.post("/auth/mfa/setup")).data); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
  };
  const confirm = async (e) => {
    e.preventDefault(); setError("");
    try {
      await api.post("/auth/mfa/confirm", { code });
      setUser({ ...user, mfa_enabled: true });
      navigate("/admin");
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
  };

  return <div className="min-h-screen bg-[#F5F5F7] dark:bg-[#161618] flex items-center justify-center px-6">
    <div className="w-full max-w-lg bg-white dark:bg-[#1C1C1E] rounded-2xl border border-slate-200 dark:border-white/10 p-8 shadow-xl">
      <div className="mb-6"><PlenaLogo /></div>
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Admin MFA kurulumu</h1>
      <p className="text-sm text-slate-500 mt-2">Authenticator uygulamanızla hesabınızı koruyun. Recovery kodlarını parola yöneticinize kaydedin; tekrar gösterilmez.</p>
      {!setup ? <button onClick={begin} className="mt-6 w-full h-11 rounded-xl bg-[#0066CC] text-white font-semibold">Kurulumu başlat</button> :
        <form onSubmit={confirm} className="mt-6 space-y-4">
          <div className="rounded-xl bg-slate-100 dark:bg-white/10 p-4 break-all text-xs text-slate-700 dark:text-slate-200">
            <p className="font-semibold mb-2">Authenticator anahtarı</p><p>{setup.secret}</p>
            <p className="font-semibold mt-4 mb-2">Recovery kodları</p>
            <div className="grid grid-cols-2 gap-1 font-mono">{setup.recovery_codes.map((c) => <span key={c}>{c}</span>)}</div>
          </div>
          <input required autoComplete="one-time-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Authenticator'daki 6 haneli kod"
            className="w-full h-11 px-4 rounded-xl bg-slate-100 dark:bg-white/10 dark:text-white border border-slate-200 dark:border-white/10" />
          <button className="w-full h-11 rounded-xl bg-[#0066CC] text-white font-semibold">MFA'yı etkinleştir</button>
        </form>}
      {error && <p className="mt-4 text-sm text-[#FF2D55]">{error}</p>}
    </div>
  </div>;
}
